import React, { useContext, useEffect, useState } from 'react';
import './HeaderCartBtn.css';
import CartIcon from "../Cart/CartIcon";
import CartContext from "../../store/cart-context";


function HeaderCartBtn( props ) {

    const [btnIsHighlighted, setBtnIsHighlighted] = useState(false);
    const cartCtx = useContext(CartContext);

    const { items } = cartCtx;

    const numberOfCartItems = cartCtx.items.reduce(( currentNumber, item ) => {
        return currentNumber + item.amount
    }, 0);

    useEffect(() => {
        if (items.length === 0) {
            return;
        }
        setBtnIsHighlighted(true);

        const timer = setTimeout(() => {
            setBtnIsHighlighted(false);
        }, 300);

        return () => {
            clearTimeout(timer);
        };
    }, [items]);

    return (
        <button className={ btnIsHighlighted ? 'button' : 'button bump' } onClick={ props.onClick }>
      <span className='icon'>
        <CartIcon/>
      </span>
            <span>Your Cart</span>
            <span className="badge">{ numberOfCartItems }</span>
        </button>
    );
}

export default HeaderCartBtn;